import React from "react";
import "./styles/Panel.css";

/**
 * Panel - A bordered surface with an optional titled header.
 *
 * @param {Object} props
 * @param {string} props.title - Header title
 * @param {string} props.subtitle - Line under the title
 * @param {React.ReactNode} props.actions - Header right-hand content
 * @param {React.ReactNode} props.footer - Footer content
 * @param {boolean} props.flush - Remove body padding, for lists and tables
 * @param {React.ReactNode} props.children - Body content
 */
const Panel = ({
  title,
  subtitle,
  actions,
  footer,
  flush = false,
  className = "",
  children,
}) => {
  const hasHeader = Boolean(title || subtitle || actions);

  return (
    <section
      className={["dsPanel", hasHeader && children ? "hasDivider" : "", className]
        .filter(Boolean)
        .join(" ")}
    >
      {hasHeader && (
        <div className="dsPanelHeader">
          <div className="dsPanelHeading">
            {title && <span className="dsPanelTitle">{title}</span>}
            {subtitle && <span className="dsPanelSubtitle">{subtitle}</span>}
          </div>
          {actions && <div className="dsPanelActions">{actions}</div>}
        </div>
      )}
      {children && (
        <div className={`dsPanelBody ${flush ? "flush" : ""}`}>{children}</div>
      )}
      {footer && <div className="dsPanelFooter">{footer}</div>}
    </section>
  );
};

export default Panel;
